import React, {useEffect,useState} from 'react';   
import { Link } from 'react-router-dom'; 
import paths from '../../routes/paths'
import Spinner from '../Common/Spinner';
import Product from './Product'
import Pagination from '../Common/Pagination'
import MetaTags from '../Common/MetaTags';

const  KurtasKurtis = () => { 
  const [products, setProducts] =  useState<any[]>([]); //useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true); 
  //const {categories} = useSelector((state:any) => state.settings) 
 
 
  useEffect(() => {
    fetchAllProducts(currentPage);
  }, [currentPage]);

 

  const fetchAllProducts = async (page) => {
    setLoading(true);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?subcategory=Kurtis&page=${page}&per_page=40&category=&searchTxt=`);
      
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json(); // Parse the JSON data
      setProducts(data.data);
      setTotalPages(data.total_pages);
    //  setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0)
  };

  // const searchFilters = async ( selectedCategory,selectedSearchTxt,selectedPriceRange) => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/v1/products?subcategory=Kurtis&page=${currentPage}&per_page=40&category=${selectedCategory}&priceRange=${selectedPriceRange}&searchTxt=${selectedSearchTxt}`);
      
  //     // Check if the response is OK (status code 200-299)
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }
  
  //     const data = await response.json(); // Parse the JSON data
  //     setProducts(data.data);
  //     setTotalPages(data.total_pages);
  //     //setCategories(data.categories);

  //   } catch (error) {
  //     console.error("Error fetching items:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // } 
  
  return (
    <>
       <MetaTags
        title={products[0]?.['category']['meta_title']}
        description={products[0]?.['category']['meta_description']}
        url="https://www.anuughacollections.com/women-kurtas-kurtis-suits"
        image={process.env.REACT_APP_SERVER_URL + ( products[0]?.variants[0].variant_images[0]?.display_image_url)}
      />
      <div className="page-content bg-light">

        <div className="dz-bnr-inr bg-secondary overlay-black-light bannerBG" >
          <div className="container">
            <div className="dz-bnr-inr-entry">
              <h1>All Kurtis</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={paths.store} className=" menu-title ">Home</Link></li>
                  <li className="breadcrumb-item">All Kurtis</li>
                </ul>
              </nav>
            </div>
          </div>	
        </div>

        <section className="content-inner-3 pt-3 z-index-unset">
          <div className="container-fluid">
            <div className="row">
                <div className="col-100 col-xl-12">
                
                <div className="row">
                  <div className="col-12 tab-content shop-" id="pills-tabContent">
                    <div className="tab-pane fade active show" id="tab-list-grid" role="tabpanel" aria-labelledby="tab-list-grid-btn">
                      {loading ? (
                        <Spinner/>
                      ) : (
                            <div className="row gx-xl-4 g-3">
                              {products && products.map((product,index) => 
                                <Product key={index} product={product} index={index}/> 
                              )}
                            
                            </div>
                          )}
                    </div>
                  </div>
                </div>
                
                {!loading &&  
                      <div className="row page mt-0">
                        <div className="col-md-6">
                          <p className="page-text">Showing 1–5 Of {totalPages} Results</p>
                        </div>
                        <div className="col-md-6">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                          />
                          {products.length === 0 &&            
                            <div className="col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 m-md-b15 m-b30">
                                <div className="shop-card style-1">No Products.</div>
                            </div>
                          }
                        </div>
                      </div>
                    }
              </div>
            </div>
          </div>
        </section> 
        
      </div> 
    </>
  );
}

export default KurtasKurtis;

 
